import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const result = await login(email.trim());
      if (result.success) {
        setSent(true);
      } else {
        setError(result.message || 'Something went wrong');
      }
    } catch {
      setError('Failed to send magic link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__brand">
          <span className="auth-card__logo">
            <span className="wordmark">Histo<span className="wordmark__r">R</span>yjki</span>
          </span>
          <p className="auth-card__tagline">Turn bedtime stories into illustrated books</p>
        </div>

        {sent ? (
          <div className="auth-card__sent">
            <p className="auth-card__sent-message">
              We sent a magic link to <strong>{email}</strong>. Click the link in the email to sign in.
            </p>
            <Button
              variant="ghost"
              onClick={() => {
                setSent(false);
                setEmail('');
              }}
            >
              Use a different email
            </Button>
          </div>
        ) : (
          <form className="auth-card__form" onSubmit={handleSubmit}>
            <Input
              label="Email address"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={error}
              autoFocus
              autoComplete="email"
            />
            <Button
              type="submit"
              variant="accent"
              loading={loading}
              className="auth-card__submit"
            >
              Send Magic Link
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
